import {UserPermission} from "../../model/user/UserPermission";

export interface HeaderMenuData {
	/**
	 * Label to display.
	 */
	label: string,
	/**
	 * Main rote store to highlight header menu item.
	 */
	route: string,
	/**
	 * Sub routes of header menu.
	 */
	subRoutes?: DropDownRouteData[],
	/**
	 * Permissions allowed for route
	 */
	allowedPermissions?: string[]
}

export interface DropDownRouteData {
	/**
	 * Route to navigate to.
	 */
	route: string,
	/**
	 * Label to display.
	 */
	label: string,
	/**
	 * Permissions allowed for subroute
	 */
	allowedPermissions?: string[]
}


/**
 * Workspace routes configuration for top header navigation.
 */
export const workRoutes: HeaderMenuData[] = [
	{
		label: "Leads",
		route: "/app/leads",
		subRoutes: [
			{
				label: "Leads",
				route: "/app/leads",
				allowedPermissions: [
					UserPermission.LeadView,
					UserPermission.LeadNotes,
					UserPermission.LeadEdit,
					UserPermission.LeadQuotes
				]
			},
			{
				label: "Create Lead",
				route: "/app/leads/create",
				allowedPermissions: [UserPermission.LeadCreate]
			},
		],
		allowedPermissions: [
			UserPermission.LeadView,
			UserPermission.LeadCreate,
			UserPermission.LeadNotes,
			UserPermission.LeadEdit,
			UserPermission.LeadQuotes,
			UserPermission.LeadCreate
		]
	},
	{
		label: "Jobs",
		route: "/app/jobs",
		subRoutes: [
			{
				label: "Jobs",
				route: "/app/jobs",
				allowedPermissions: [
					UserPermission.LeadView, //TODO change to Job View
				]
			},
			{
				label: "New EV charging job",
				route: "/app/jobs/ev-charging/create",
				allowedPermissions: [UserPermission.AdminAll]
			},
		],
		allowedPermissions: [
			UserPermission.LeadView,
		]
	},
	{
		label: "Appointments",
		route: "/app/schedule",
		subRoutes: [
			{
				label: "Day View",
				route: "/app/schedule/plan",
				//TODO: apply proper permissions
				allowedPermissions: [UserPermission.ScheduleAppointments]
			},
			{
				label: "Sales Engineer SMS",
				route: "/app/schedule/appointments",
				allowedPermissions: [UserPermission.ScheduleAppointments]
			},
			{
				label: "Real-time Routing Map",
				route: "/app/schedule/map",
				allowedPermissions: [UserPermission.ScheduleMap]
			},
			{
				label: "Full Calendar",
				route: "/app/schedule/appointments/calendar",
				//TODO: apply proper permissions
				allowedPermissions: [UserPermission.ScheduleAppointments]
			}
		],
		allowedPermissions: [UserPermission.ScheduleMap, UserPermission.ScheduleAppointments]
	},
	{
		label: "Admin",
		route: "/app/admin",
		allowedPermissions: [UserPermission.AdminUsers,
			UserPermission.AdminPartnerBrands,
			UserPermission.AdminAll,
			UserPermission.AdminMerchantBranchLocations]
	},
	{
		//TODO: apply proper permissions
		label: "Accounting",
		route: "/app/accounting",
		subRoutes: [
			{
				label: "Transactions",
				route: "/app/accounting/transactions",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "General ledger",
				route: "/app/accounting/general_ledger",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "Chart of accounts",
				route: "/app/accounting/accounts",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "Journal",
				route: "/app/accounting/journal",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "Bills",
				route: "/app/accounting/bills",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "Bills workspace",
				route: "/app/accounting/bills_workspace",
				allowedPermissions: [UserPermission.AdminAll]
			},
			{
				label: "RTFO credit submissions",
				route: "/app/accounting/rtfo_submissions",
				allowedPermissions: [UserPermission.AdminAll]
			}
		],
		allowedPermissions: [UserPermission.AdminAll]
	},

];